import React, { useState, useContext, useMemo, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import Dashboard from "./components/dashboard";
import Appointments from "./components/appointments";
import Reviews from "./components/reviews";
import Profile from "./components/profile/Profile";
import ForgotPassword from "./components/forgotpassword";
import Lockscreen from "./components/lockscreen";
import { Appcontext } from "../approuter";
import Projects from "./components/projects/Projects";
import ServiceProviderRoutes from "../routes/ServiceProviderRoutes";
import Departments from "./components/departments/Departments";
import Designations from "./components/designations/Designations";
import { ShiftPlanning } from "./components/shiftsPlanning/ShiftPlanning";
import Shifts from "./components/shiftsPlanning/ManageShifts/Shifts";
import Leaves from "./components/leaves/Leaves";
import { SocketContext } from "../context/SocketContext";
import { isAuthenticated } from "../commons/Auth/auth";
import Clients from "./components/clients/Clients";
import ClientsProjectsListView from "./components/clients/ProjectsListView/ProjectsListView";
import Invoices from "./components/Invoices/Invoices";
import tickets from "./components/tickets/tickets";
import Tasks from "./components/tasks/Tasks";
import RoomManagment from "./components/roomManagment/RoomManagment";
import Attendance from "./components/Attendance/Attendance";
import ServiceProviderAssetsManagement from "./components/assetsManagement/AssetsManagement";
import ServiceProviderDeals from "./components/deals/DealsManagement";
import DealDetails from "./components/deals/DealDetails/DealDetails";
import ServiceProviderPipelines from "./components/pipelines/PipelinesManagement";
import Meetings from "./components/bbbMeetings/Meetings";
import Contracts from "./components/contracts/Contracts";
import ContractDetails from "./components/contracts/ContractDetails";
import Inventory from "./components/inventory/Inventory";
import AiFeatures from "./components/ai/ai";
import Boardingtickets from "./components/tickets/Boardingtickets";
import RoleManagement from "./components/rolesAndPermissions/RolesManagement";
import ProtectedRoutes from "../routes/ProtectedRoutes";
import SalarySlip from "./components/salarySlips/SalarySlips";
import ProjectDetailsView from "../commons/Projects/ProjectDetailsView/ProjectDetailsView";
import LoginContainer from "../normalUsers/components/login/login";
import predefinedvalues from "./components/predefinedvalues/predefinedvalues";
import ChatPage from "../commons/Chats/Chat";
import CommonDocumentsManagement from "../commons/documents/DocumentsManagement";
import axios from "axios";
import Employees from "./components/employees/Employees";
import EmployeesProfile from "./components/employees/EmployeesProfile/Profile";
import Offers from "./components/Offers/Offers";
import Auftragssuche from "./components/Auftragssuche/Auftragssuche";
import VendorContracts from "./components/vendorContracts/VendorContracts";
import Measurements from "./components/measurements/Measurements";
import MeasurementEditor from "./components/measurements/MeasurementEditor";
import WorkReports from "./components/workReports/WorkReports";
import WorkReportEditor from "./components/workReports/WorkReportEditor";
import Maintenance from "./components/maintenance/Maintenance";
import VisitExecution from "./components/maintenance/VisitExecution";
import Subcontractors from "./components/subcontractors/Subcontractors";
import SubcontractorDetail from "./components/subcontractors/SubcontractorDetail";
import Materials from "./components/materials/Materials";
import ChangeOrders from "./components/changeOrders/ChangeOrders";
import ChangeOrderEditor from "./components/changeOrders/ChangeOrderEditor";
import SiteDocs from "./components/siteDocs/SiteDocs";
import Warranty from "./components/warranty/Warranty";
import AcceptanceEditor from "./components/warranty/AcceptanceEditor";
import WarrantyDetail from "./components/warranty/WarrantyDetail";
import SiteDocEditor from "./components/siteDocs/SiteDocEditor";
import Safety from "./components/safety/Safety";
import SafetySessionEditor from "./components/safety/SessionEditor";
import RiskAssessmentEditor from "./components/safety/AssessmentEditor";
import Apprenticeship from "./components/apprenticeship/Apprenticeship";
import Berichtsheft from "./components/apprenticeship/Berichtsheft";
import ApprenticeWeeks from "./components/apprenticeship/ApprenticeWeeks";
import BerichtsheftWeek from "./components/apprenticeship/ReportEditor";
import Funding from "./components/funding/Funding";
import FundingCaseEditor from "./components/funding/FundingCaseEditor";
import SiteDiary from "./components/siteDiary/SiteDiary";
import SiteDiaryDay from "./components/siteDiary/SiteDiaryDay";
import Dispatch from "./components/dispatch/Dispatch";
import MyDay from "./components/dispatch/MyDay";
import Mail from "./components/mail/Mail";
import AccountingRouter from "./components/accounting/AccountingRouter";
import MailOAuthCallback from "./components/mail/MailOAuthCallback";
import EmailSettings from "./components/settings/EmailSettings";
import MessagingSettings from "./components/notifications/MessagingSettings";
import { UserContextProvider } from "../context/UserContext";
import AssistantWidget from "./components/assistant/AssistantWidget";
import AssistantUsage from "./components/assistant/AssistantUsage";

const ServiceProviderAppUniversal = function (props) {
  const socket = useContext(SocketContext);
  const { isAuth, setIsAuth } = useContext(Appcontext);
  const location = props?.location;

  useMemo(() => {
    if (
      location?.pathname == "/login" ||
      location?.pathname == "/user/register" ||
      location?.pathname == "/user/forgotPassword" ||
      location?.pathname == "/user/lockscreen" ||
      location?.pathname == "/user/conform-email"
    ) {
      setIsAuth("serviceProvider");
    } else {
      setIsAuth("user");
    }
  }, [location]);

  useEffect(() => {
    if (socket) {
      socket.emit("join", { userId: isAuthenticated()._id });
    }
  }, [socket, location]);

  return (
    <UserContextProvider>
      <Switch>
        <Route path="/login" exact component={LoginContainer} />
        <Route path="/user/forgotPassword" exact component={ForgotPassword} />
        <ServiceProviderRoutes path="/user/lockscreen" exact component={Lockscreen} />
        <ServiceProviderRoutes path="/user" exact component={Dashboard} />
        <ServiceProviderRoutes path="/user/appointment-list" exact component={Appointments} />
        <ServiceProviderRoutes path="/user/departments" exact component={Departments} />
        <ServiceProviderRoutes path="/user/designations" exact component={Designations} />
        <ServiceProviderRoutes path="/user/leaves" exact component={Leaves} />
        <ServiceProviderRoutes path="/user/employees" exact component={Employees} />
        <ServiceProviderRoutes path="/user/user-profile/:id" exact component={EmployeesProfile} />
        <ServiceProviderRoutes path="/user/shifts-planning" exact component={ShiftPlanning} />
        <ServiceProviderRoutes path="/user/calendar" exact component={Appointments} />
        <ServiceProviderRoutes path="/user/tickets/:id" exact component={tickets} />
        <ServiceProviderRoutes path="/user/Boards" exact component={Boardingtickets} />
        <ServiceProviderRoutes path="/user/tasks" exact component={Tasks} />
        <ServiceProviderRoutes path="/user/shifts" exact component={Shifts} />
        <ServiceProviderRoutes path="/user/clients" exact component={Clients} />
        <ServiceProviderRoutes
          path="/user/clients/projects/:id"
          exact
          component={ClientsProjectsListView}
        />
        {/* <ServiceProviderRoutes path="/user/tickets" exact component={tickets} /> */}
        <ServiceProviderRoutes path="/user/tasks" exact component={Tasks} />
        <ServiceProviderRoutes path="/user/projects" exact component={Projects} />
        {/* <ServiceProviderRoutes path="/user/projects/:id/invoice" exact component={Projects} /> */}
        <ProtectedRoutes path="/user/projects/:id" exact component={ProjectDetailsView} />
        <ServiceProviderRoutes path="/user/room-management" exact component={RoomManagment} />
        <ServiceProviderRoutes
          path="/user/room-management-details"
          exact
          component={RoomManagment}
        />
        <ServiceProviderRoutes path="/user/ai" exact component={AiFeatures} />
        <ServiceProviderRoutes path="/user/attendance" exact component={Attendance} />
        {/* <ServiceProviderRoutes path="/user/attendance-table" exact component={EmployeeAttendance} /> */}
        <ServiceProviderRoutes path="/user/reviews" exact component={Reviews} />
        <ServiceProviderRoutes path="/user/contracts" exact component={Contracts} />
        <ServiceProviderRoutes path="/user/vendor-contracts" exact component={VendorContracts} />
        <ServiceProviderRoutes path="/user/measurements" exact component={Measurements} />
        <ServiceProviderRoutes path="/user/measurements/:id" exact component={MeasurementEditor} />
        <ServiceProviderRoutes path="/user/work-reports" exact component={WorkReports} />
        <ServiceProviderRoutes path="/user/work-reports/:id" exact component={WorkReportEditor} />
        <ServiceProviderRoutes path="/user/maintenance" exact component={Maintenance} />
        <ServiceProviderRoutes path="/user/maintenance/visits/:id" exact component={VisitExecution} />
        <ServiceProviderRoutes path="/user/subcontractors" exact component={Subcontractors} />
        <ServiceProviderRoutes path="/user/subcontractors/:id" exact component={SubcontractorDetail} />
        <ServiceProviderRoutes path="/user/materials" exact component={Materials} />
        <ServiceProviderRoutes path="/user/change-orders" exact component={ChangeOrders} />
        <ServiceProviderRoutes path="/user/change-orders/:id" exact component={ChangeOrderEditor} />
        <ServiceProviderRoutes path="/user/site-docs" exact component={SiteDocs} />
        <ServiceProviderRoutes path="/user/site-docs/:id" exact component={SiteDocEditor} />
        <ServiceProviderRoutes path="/user/safety" exact component={Safety} />
        <ServiceProviderRoutes path="/user/safety/sessions/:id" exact component={SafetySessionEditor} />
        <ServiceProviderRoutes
          path="/user/safety/risk-assessments/:id"
          exact
          component={RiskAssessmentEditor}
        />
        <ServiceProviderRoutes path="/user/apprenticeship" exact component={Apprenticeship} />
        {/* Not ServiceProviderRoutes: apprentices and their trainers reach their own Berichtsheft
            without the Apprenticeship permission. The server decides who sees what. */}
        <ProtectedRoutes path="/user/berichtsheft" exact component={Berichtsheft} />
        <ProtectedRoutes path="/user/berichtsheft/apprentices/:id" exact component={ApprenticeWeeks} />
        <ProtectedRoutes path="/user/berichtsheft/reports/:id" exact component={BerichtsheftWeek} />
        <ServiceProviderRoutes path="/user/funding" exact component={Funding} />
        <ServiceProviderRoutes path="/user/funding/:id" exact component={FundingCaseEditor} />
        <ServiceProviderRoutes path="/user/site-diary" exact component={SiteDiary} />
        <ServiceProviderRoutes
          path="/user/site-diary/:projectId/:date"
          exact
          component={SiteDiaryDay}
        />
        <ServiceProviderRoutes path="/user/dispatch" exact component={Dispatch} />
        {/* Not ServiceProviderRoutes: every employee sees their own day without the Dispatch
            permission. The server decides whose jobs are shown. */}
        <ProtectedRoutes path="/user/my-day" exact component={MyDay} />
        <ServiceProviderRoutes path="/user/warranty" exact component={Warranty} />
        <ServiceProviderRoutes path="/user/warranty/acceptances/:id" exact component={AcceptanceEditor} />
        <ServiceProviderRoutes path="/user/warranty/warranties/:id" exact component={WarrantyDetail} />
        <ServiceProviderRoutes path="/user/accounting" component={AccountingRouter} />
        <ServiceProviderRoutes path="/user/invoices" exact component={Invoices} />
        <ServiceProviderRoutes path="/user/offers" exact component={Offers} />
        <ServiceProviderRoutes path="/user/offers/auftragssuche" exact component={Auftragssuche} />
        <ServiceProviderRoutes path="/user/inventory" exact component={Inventory} />
        <ServiceProviderRoutes path="/user/profile" exact component={Profile} />
        {/* Not a ServiceProviderRoutes: an employee without the Contracts permission still
            reads and signs their own contract here. The server decides who sees what. */}
        <ProtectedRoutes path="/user/contract/:contractId" exact component={ContractDetails} />
        <ServiceProviderRoutes
          path="/user/assests-controls"
          exact
          component={ServiceProviderAssetsManagement}
        />
        <ServiceProviderRoutes path="/user/deals" exact component={ServiceProviderDeals} />
        <ServiceProviderRoutes path="/user/deals/:id" exact component={DealDetails} />
        <ServiceProviderRoutes path="/user/pipelines" exact component={ServiceProviderPipelines} />
        <ServiceProviderRoutes path="/user/directory" exact component={CommonDocumentsManagement} />
        <ServiceProviderRoutes path="/user/meetings" exact component={Meetings} />
        <ServiceProviderRoutes path="/user/mail" exact component={Mail} />
        <ServiceProviderRoutes path="/user/mail/oauth/callback" exact component={MailOAuthCallback} />
        <ServiceProviderRoutes path="/user/predefinedvalues" exact component={predefinedvalues} />
        <ServiceProviderRoutes path="/user/roles" exact component={RoleManagement} />
        <ServiceProviderRoutes path="/user/settings/email" exact component={EmailSettings} />
        <ServiceProviderRoutes path="/user/settings/messaging" exact component={MessagingSettings} />
        <ServiceProviderRoutes path="/user/settings/assistant" exact component={AssistantUsage} />
        <ServiceProviderRoutes path="/user/salary" exact component={SalarySlip} />
        <ServiceProviderRoutes exact path="/user/chats" component={ChatPage} />
      </Switch>
      {/* Voice/text assistant on every /user page (hidden when the server has no model key) */}
      <AssistantWidget />
    </UserContextProvider>
  );
};

export default ServiceProviderAppUniversal;
